<div class="glossary-term-row">
  <div class="glossary-term-row__heading">
    <span class="glossary-term-row__term">{{ term.term }}</span>
  </div>
  <div class="glossary-term-row__body">
    <p class="glossary-term-row__description">{{ term.description }}</p>
  </div>
</div>
